import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  href: "/",
  class: "font-bold text-lg flex items-center"
}
const _hoisted_2 = { class: "grid w-[600px] grid-cols-2 gap-5 p-4" }
const _hoisted_3 = { class: "flex flex-col gap-2" }
const _hoisted_4 = { class: "mb-1 font-semibold leading-none text-foreground" }
const _hoisted_5 = { class: "line-clamp-2 text-muted-foreground" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "hidden lg:flex" }

import { useColorMode } from "@vueuse/core";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/landingPage/ui/navigation-menu";

import { Button } from "@/components/landingPage/ui/button";

import { ChevronsDown } from "lucide-vue-next";
import ToggleTheme from "./ToggleTheme.vue";

interface RouteProps {
  href: string;
  label: string;
}

interface FeatureProps {
  title: string;
  description: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const mode = useColorMode();
mode.value = "dark";

const routeList: RouteProps[] = [
  {
    href: "#benefits",
    label: "Mission",
  },
  {
    href: "#team",
    label: "Équipe",
  },
  {
    href: "#contact",
    label: "Contact",
  },
  {
    href: "#faq",
    label: "FAQ",
  },
];

const featureList: FeatureProps[] = [
  {
    title: "Parcours Jeune",
    description: "Découvrir ses forces et construire son projet professionnel.",
  },
  {
    title: "Parcours Accompagnateur",
    description: "Outils pour suivre et accompagner efficacement les jeunes.",
  },
  {
    title: "Portail Entreprise",
    description: "Recruter des talents neurodivergents et sensibiliser vos équipes.",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({
      'shadow-light': _unref(mode) === 'light',
      'shadow-dark': _unref(mode) === 'dark',
      'w-[90%] md:w-[70%] lg:w-[75%] lg:max-w-screen-xl top-5 mx-auto sticky border z-40 rounded-2xl flex justify-between items-center p-2 shadow-md': true,
    }),
    style: {"background-color":"hsl(var(--card))","opacity":"1"}
  }, [
    _createElementVNode("a", _hoisted_1, [
      _createVNode(_unref(ChevronsDown), { class: "bg-gradient-to-tr from-[#ff9500] via-[#ff9500]/70 to-[#ff9500] rounded-lg w-9 h-9 mr-2 border text-white" }),
      _cache[0] || (_cache[0] = _createTextVNode(" Autrement Capable"))
    ]),
    _createVNode(_unref(NavigationMenu), { class: "hidden lg:block" }, {
      default: _withCtx(() => [
        _createVNode(_unref(NavigationMenuList), null, {
          default: _withCtx(() => [
            _createVNode(_unref(NavigationMenuItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NavigationMenuContent), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _cache[1] || (_cache[1] = _createElementVNode("img", {
                        src: "https://www.radix-vue.com/logo.svg",
                        alt: "Beach",
                        class: "h-full w-full rounded-md object-cover"
                      }, null, -1)),
                      _createElementVNode("ul", _hoisted_3, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(featureList, ({ title, description }) => {
                          return _createElementVNode("li", {
                            key: title,
                            class: "rounded-md p-3 text-sm hover:bg-muted"
                          }, [
                            _createElementVNode("p", _hoisted_4, _toDisplayString(title), 1),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(description), 1)
                          ])
                        }), 64))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(NavigationMenuItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NavigationMenuLink), { asChild: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routeList, ({ href, label }) => {
                      return _createVNode(_unref(Button), {
                        key: label,
                        "as-child": "",
                        variant: "ghost",
                        class: "justify-start text-base"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", { href: href }, _toDisplayString(label), 9, _hoisted_6)
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(ToggleTheme)
    ])
  ], 2))
}
}

})